import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MessageService } from 'primeng/api';
import { DialogModule } from 'primeng/dialog';
import { ImageModule } from 'primeng/image';
import { FileViewerComponent } from '../../../components/file-viewer';

export enum FileType {
  Image = 'image',
  Video = 'video',
  Audio = 'audio',
  Doc = 'doc',
  Pdf = 'pdf'
}

@Component({
  selector: 'app-repository-show-file-dialog',
  standalone: true,
  imports: [DialogModule, ImageModule, CommonModule, FileViewerComponent],
  providers: [MessageService],
  templateUrl: './repository-show-file-dialog.component.html',
  styleUrls: ['./repository-show-file-dialog.component.scss'],
})
export class RepositoryShowFileDialogComponent {
  @Input() title: string;
  @Input() message: string;
  @Input() closeLabel: string;
  @Input() fileUrl: string;
  @Input() fileName: string;
  @Input() visible: boolean = true;
  @Input() fileType?: FileType;
  @Output() close = new EventEmitter<void>();

  constructor() {}
}
